import type { KgInsightThemeType } from '@api/api/kg-insights';
import { useThemeCompanyCount } from '@terminal/react-query-hooks/themes/useThemeCompanyCount';
import { useTranslation } from 'react-i18next';

export interface ThemeCompanyCountProps {
  themeId: string;
  themeType?: KgInsightThemeType;
}

export const ThemeCompanyCount = ({
  themeId,
  themeType,
}: ThemeCompanyCountProps) => {
  const { t } = useTranslation('widget');
  const shouldShowCompanyCount = themeType === 'industry';
  const companyCount = useThemeCompanyCount(
    shouldShowCompanyCount ? themeId : ''
  );

  if (!shouldShowCompanyCount || companyCount === undefined) {
    return null;
  }

  return (
    <>
      {' · '}
      {t('widget:themeOverview.companiesCounter', { count: companyCount })}
    </>
  );
};
